<p-overlayPanel appendTo="body" #templateViewer [style]="{width: '30vw', height:'30vh'}" styleClass="overflow-y-scroll">

    <div *ngIf="selectedTemplate" [innerHtml]="selectedTemplate.body"></div>
</p-overlayPanel>


<p-overlayPanel appendTo="body" #newTemplateEditor>
    <app-email-templates-editor (cancelled)="cancelButtonPressed()" (saved)="saveButtonPressed($event)">

    </app-email-templates-editor>
</p-overlayPanel>

<p-overlayPanel appendTo="body" #templateEditor >
    <app-email-templates-editor [(templateEmail)]="selectedTemplate" (cancelled)="cancelButtonPressed()" (saved)="saveButtonPressed($event)">

    </app-email-templates-editor>
</p-overlayPanel>


<p-panel>
    <ng-template pTemplate="header">
        <div><h4>Template Emails</h4></div>
        <div *ngIf="allowEdit" class="flex flex-auto justify-content-end gap-2">
            <p-button icon="pi pi-plus" label="New Template" [text]="true"  (onClick)="newTemplateEmail(); templateEditor.toggle($event)"></p-button>
            
        </div>
    </ng-template>
    <div class="flex flex-column overflow-y-scroll">
        <p-table [value]="(templateEmails$ | async) || []" [paginator]="true" sortMode="single" [rows]="5">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngIf="allowApply"></th>
                    <th>Template Name</th>
                    <th>Subject</th>
                    <th>Date Last Saved</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-email>
                <tr>
                    <td *ngIf="allowApply">
                        <p-button label="Apply" icon="pi pi-file-export" (onClick)="applyButtonPressed($event, email)"></p-button>
                    </td>
                    <td>
                        {{email.templateName}}
                    </td>
                    <td>
                        {{email.subject}}
                    </td>
                    <td>
                       {{email.dateLastSaved | date :'short'}} 
                    </td>
                    <td>
                            <p-button icon="pi pi-eye" label="View" [text]="true"  (onClick)="selectedTemplate = email; templateViewer.toggle($event)"></p-button>
                            <p-button *ngIf="allowEdit" icon="pi pi-pencil" label="Edit" [text]="true" (onClick)="selectedTemplate = email; templateEditor.toggle($event)"></p-button>        
                            <p-button *ngIf="allowEdit" label="Delete" [text]="true" severity="danger" (onClick)="deleteButtonPressed($event, email)"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>